import vtkSTLReader from './STLReader';
import vtkPLYReader from './PLYReader';
import vtkDracoReader from './DracoReader';
import vtkSTLWriter from './STLWriter';
import vtkPLYWriter from './PLYWriter';
import vtkGLTFImporter from './GLTFImporter';
import vtkIFCImporter from './IFCImporter';

export default {
  vtkSTLReader,
  vtkPLYReader,
  vtkDracoReader,
  vtkSTLWriter,
  vtkPLYWriter,
  vtkGLTFImporter,
  vtkIFCImporter,
};
